import { CloseIcon } from '@sketchnote/icons';
import { Vec } from '@tldraw/vec';
import * as React from 'react';
import { useTldrawApp } from 'sn-wb-tldraw';

export function CommentsPanel({ shapes }: any) {
  const app = useTldrawApp();
  const commentIds = Object.keys(shapes).filter((shape) => shapes[shape].type === 'comment');
  const comments = commentIds.map((id) => shapes[id]);
  const { width, height } = app.rendererBounds;

  const scrollToPoint = (point: number[]) => {
    app.setCamera(
      Vec.toFixed(Vec.add(Vec.sub([0, 0], point), [width / 2, height / 2])),
      1,
      `zoomed_to_content`
    );
    app.selectTool('select');
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: '5%',
        right: '0',
        display: 'flex',
        flexDirection: 'column',
        background: 'white',
        minWidth: '389px',
        height: '100%',
        border: 'none',
        outline: 'none',
        pointerEvents: 'all',
        width: '389px',
        overflow: 'auto',
      }}
    >
      <div className="py-16 px-24 flex justify-between items-center">
        <h3 className="font-medium text-lg">Comments</h3>

        <CloseIcon
          className="cursor-pointer transform scale-90"
          fill="#878A92"
          onClick={() => {
            app.selectTool('select');
          }}
        />
      </div>
      {comments.map((comment) => {
        if (!comment.comments.length) return;
        const firstComment = comment.comments[0];
        return (
          <div
            key={comment.id}
            className="px-24 py-16"
            onClick={() => {
              app.setDropDown(comment.id);
              scrollToPoint(comment.point);
            }}
          >
            <div className="flex items-center">
              <img
                height="20px"
                width="20px"
                className="mr-8 h-20 w-20 rounded-full"
                src={firstComment.avatar}
                loading="lazy"
              />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  justifyContent: 'center',
                }}
              >
                <div className="text-sm">{firstComment.userName}</div>
                <div className="text-xss text-gray-500">{firstComment.time}</div>
              </div>

              <div className="text-xs text-gray-500">
                {comment.comments.length - 1}{' '}
                {comment.comments.length - 1 === 1 ? 'reply' : 'replies'}
              </div>
            </div>
            <p
              className="text-sm mt-8 leading-20 break-words"
              dangerouslySetInnerHTML={{ __html: firstComment.message }}
            ></p>
          </div>
        );
      })}
    </div>
  );
}
